










import Vue from 'vue'
import { PropValidator, RenderContext } from 'vue/types/options'
import IgIcon from '@/components/IgIcon.vue'
import { DeviceType } from '@/types/api'
type direction_t = 'left' | 'right'
export default Vue.extend({
  components: {
    IgIcon
  },
  props: {
    type: {
      type: String
    } as PropValidator<DeviceType>,
    side: {
      type: String,
      default: 'left'
    } as PropValidator<direction_t>,
    showText: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    iconName (): string {
      // return `ig-${this.type.toLowerCase()}-${this.side.toLowerCase()}-side`
      // return this.type === 'TX' ? 'videocam' : 'tv'
      return this.type === 'TX' ? 'local_movies' : 'tv'
    }
  }
})
